"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/createForOfIteratorHelper"));

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

var _franprovince = require("@/api/franprovince");

var _BackToTop = _interopRequireDefault(require("@/components/BackToTop"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _lodash = _interopRequireDefault(require("lodash"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Secondary package based on el-pagination
var _default = {
  name: 'franRegion',
  components: {
    BackToTop: _BackToTop.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 50,
        sort: 'create_time',
        order: 'desc'
      },
      dataForm: {
        id: undefined,
        name: '',
        provinces: []
      },
      sysProvinces: [],
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑加盟信息接收邮箱',
        create: '创建加盟信息接收邮箱'
      },
      rules: {
        region: [{
          required: true,
          message: '大区名称不能为空',
          trigger: 'blur'
        }],
        regionManager: [{
          required: true,
          message: '大区总名称不能为空',
          trigger: 'blur'
        }],
        regionManagerMail: [{
          required: true,
          message: '大区总邮箱不能为空',
          trigger: 'blur'
        }]
      },
      spanArr: [] //是否需要合并 数据预处理

    };
  },
  created: function created() {
    var _this = this;

    var regions = this.$store.state.panel.regions;
    regions.forEach(function (e) {
      var province = {
        id: e.name,
        name: e.name
      };

      _this.sysProvinces.push(province);

      if (e.name.indexOf("江苏") >= 0 || e.name.indexOf("浙江") >= 0 || e.name.indexOf("四川") >= 0 || e.name.indexOf("广东") >= 0) {
        //只有这2个省有市选择
        province.children = [];
        e.children.forEach(function (c) {
          province.children.push({
            id: c.name,
            name: c.name
          });
        });
      }
    });
    this.sysProvinces.push({
      id: '线上',
      name: '线上'
    });
    this.sysProvinces.push({
      id: '线下',
      name: '线下'
    });
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;
      (0, _franprovince.listProvince)(this.listQuery).then(function (response) {
        _this2.list = response.data.data.list;
        _this2.total = response.data.data.total;
        _this2.listLoading = false;

        _this2.$nextTick(function () {
          _this2.handleCellClick();
        });
      }).catch(function () {
        _this2.list = [];
        _this2.total = 0;
        _this2.listLoading = false;
      });
    },
    handleCellClick: function handleCellClick() {
      this.list.forEach(function (d) {
        d['isSpan0'] = false;
        d['isSpan1'] = false;
        d['isSpan2'] = false;
      });
    },
    handleAddProvince: function handleAddProvince() {
      //判断上一个是否为空
      var pMail = this.dataForm.provinces[this.dataForm.provinces.length - 1].provinceManagerMail;

      if (!pMail) {
        this.$notify.error({
          title: '失败',
          message: '请填写信息后再新增一行'
        });
        return;
      }

      this.dataForm.provinces.push({});
    },
    handleRemoveProvince: function handleRemoveProvince(index) {
      if (this.dataForm.provinces.length == 1) {
        this.$notify.error({
          title: '失败',
          message: '最后一项不允许删除'
        });
        return;
      }

      this.dataForm.provinces.splice(index, 1);
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleCreate: function handleCreate() {
      var _this3 = this;

      this.resetForm();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    resetForm: function resetForm() {
      this.dataForm = {
        id: undefined,
        name: '',
        provinces: [{}]
      };
    },
    createData: function createData() {
      var _this4 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this4.dataForm)); //判断上一个是否为空

          var pMail = data.provinces[data.provinces.length - 1].provinceManagerMail;

          if (!pMail) {
            _this4.$notify.error({
              title: '失败',
              message: '请将省份信息填写完整'
            });

            return;
          }

          console.info(_this4.dataForm); //将province数组格式化

          data.provinces.forEach(function (p) {
            p.province = p.province.join(';');
          });
          (0, _franprovince.createProvince)(data).then(function (response) {
            _this4.dialogFormVisible = false;

            _this4.$notify.success({
              title: '成功',
              message: '创建成功'
            });

            _this4.getList();
          }).catch(function (response) {
            _this4.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    handleUpdateProvince: function handleUpdateProvince(row) {
      var _this5 = this;

      (0, _franprovince.readProvince)({
        region: row.region
      }).then(function (res) {
        var province = res.data.data;
        province.provinces.forEach(function (p) {
          p.province = p.province.split(';');
        });
        console.info(province);
        _this5.dataForm = province;
        _this5.dialogStatus = 'update';
        _this5.dialogFormVisible = true;

        _this5.$nextTick(function () {
          _this5.$refs['dataForm'].clearValidate();
        });
      });
    },
    updateData: function updateData() {
      var _this6 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this6.dataForm)); //判断上一个是否为空

          var pMail = data.provinces[data.provinces.length - 1].provinceManagerMail;

          if (!pMail) {
            _this6.$notify.error({
              title: '失败',
              message: '请将省份信息填写完整'
            });

            return;
          } //将province数组格式化


          data.provinces.forEach(function (p) {
            p.province = p.province.join(';');
          });
          (0, _franprovince.updateProvince)(data).then(function () {
            var _iterator = (0, _createForOfIteratorHelper2.default)(_this6.list),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var v = _step.value;

                if (v.id === _this6.dataForm.id) {
                  var index = _this6.list.indexOf(v);

                  _this6.list.splice(index, 1, _this6.dataForm);

                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            _this6.dialogFormVisible = false;

            _this6.$notify.success({
              title: '成功',
              message: '更新成功'
            });
          }).catch(function (response) {
            _this6.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this7 = this;

      (0, _franprovince.deleteProvince)(row).then(function (response) {
        _this7.$notify.success({
          title: '成功',
          message: '停用渠道成功'
        });

        var index = _this7.list.indexOf(row);

        _this7.list.splice(index, 1);
      }).catch(function (response) {
        _this7.$notify.error({
          title: '失败',
          message: response.data.errmsg
        });
      });
    },
    columnSpanMethod: function columnSpanMethod(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      //console.info('row', row)
      if (columnIndex < 3) {
        if (!row['isSpan' + columnIndex] && rowIndex + 1 < this.list.length && row[column.property] === this.list[rowIndex + 1][column.property]) {
          row['isSpan' + columnIndex] = this.list[rowIndex + 1]['isSpan' + columnIndex] = true;
          var mergeLineCount = 2; // 找到相同的n行

          while (rowIndex + mergeLineCount < this.list.length && row[column.property] == this.list[rowIndex + mergeLineCount][column.property]) {
            this.list[rowIndex + mergeLineCount]['isSpan' + columnIndex] = true;
            mergeLineCount++;
          }

          return {
            rowspan: mergeLineCount,
            colspan: 1
          };
        } else if (row['isSpan' + columnIndex]) {
          // 是已经被合并的单元格，则不显示
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }

      return [1, 1];
    }
  }
};
exports.default = _default;